<template>
  <div>
    <b-row>
      <b-col v-if="isLoading">
        <Loader size="md"></Loader>
      </b-col>
      <b-col v-else>
        <EXCMDevicePeripheralDeviceForm
                v-if="item"
                :type="2"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDevicePeripheralDeviceForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDevicePeripheralDeviceForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    deviceperipheraldeviceId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'excmdeviceperipheraldevice/update/isLoading',
      error: 'excmdeviceperipheraldevice/update/error',
      deleteError: 'excmdeviceperipheraldevice/del/error',
      deleteLoading: 'excmdeviceperipheraldevice/del/isLoading',
      created: 'excmdeviceperipheraldevice/create/created',
      deleted: 'excmdeviceperipheraldevice/del/deleted',
      retrieved: 'excmdeviceperipheraldevice/update/retrieved',
      updated: 'excmdeviceperipheraldevice/update/updated',
      violations: 'excmdeviceperipheraldevice/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDevicePeripheralDeviceList' })
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMDeviceShow') {
        this.$Swal({
          title: this.$t('notifications.updated'),
          type: 'success'
        })
        this.$store.state.modals.excmdeviceperipheraldevice.update.updated = 1
        this.$store.state.modals.excmdeviceperipheraldevice.update.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.deviceperipheraldeviceId) {
      this.retrieve(decodeURIComponent(this.deviceperipheraldeviceId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmdeviceperipheraldevice/create/reset',
      deleteItem: 'excmdeviceperipheraldevice/del/del',
      delReset: 'excmdeviceperipheraldevice/del/reset',
      retrieve: 'excmdeviceperipheraldevice/update/retrieve',
      updateReset: 'excmdeviceperipheraldevice/update/reset',
      update: 'excmdeviceperipheraldevice/update/update',
      updateRetrieved: 'excmdeviceperipheraldevice/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this deviceperipheraldevice ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
